import { render, staticRenderFns } from "./prontuarioRetorno.vue?vue&type=template&id=94ee9c82&scoped=true"
import script from "./prontuarioRetorno.vue?vue&type=script&lang=js"
export * from "./prontuarioRetorno.vue?vue&type=script&lang=js"
import style0 from "./prontuarioRetorno.vue?vue&type=style&index=0&id=94ee9c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ee9c82",
  null
  
)

export default component.exports